import type { CountryKey, LocaleCode, Testimonial } from "~/types";

type PageToTestimonials = Partial<Record<CountryKey | 'home', Testimonial[]>>;

export default {
  en: {},
  sv: {},
  he: {
    home: [
      {
        name: "Moti B.",
        body: "הוצאנו ויזות למרוקו. קיבלנו שירות מקצועי, אמין, ידידותי , טיפול מהיר ומיידי בכל בקשה שאלה ובעיה שצצה במהלך הוצאת הויזה. מומלץ ביותר 💐✌",
        date: "3 באוגוסט 2025",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "מני מ.",
        body: "כל כך קל ופשוט..מילאתי פרטים,שילמתי וקיבלתי תוך יומיים..בלי כאבי ראש טבלי בלבולי מוח..פשוט שירות מושלם! ממליץ מאוד מאוד!!",
        date: "11 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/XgZ6U4WiDdg37HB59"
      },
      {
        name: "Sabrin N.",
        body: "מושלםםםם , מעל ומעבר , סבלנות ואדיבות שאין דברים כאלה, מקצועיות ברמה הכי גבוהה שיש, שירות סוף הדרך! ממליצה בחום! ותודה מכל הלב🩵 …",
        date: "18 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/m1F42Z4iBQSLNYJC8"
      },
      {
        name: "Yehuda N.",
        body: "ברצוני להודות מכל הלב לאורן נציג השירות שטיפל בי במסירות ובאדיבות ....תוך מענה לכל השאלות ...וממש בפחות מ 24 שעות כבר קיבלתי את הויזה ...תוך כדי מתן הסברים וסיוע...לכן אני מבקש להודות על השירות וגם להמליץ עליו...תודה רבה",
        date: "9 באוקטובר 2024",
        img: "easy.png",
        url: "https://easy.co.il/page/10122959"
      },
      {
        name: "Nira S.",
        body: "יחס אישי מהיר ונוח ממש קל ופשוט ממליצה מאוד",
        date: "28 באפריל 2025",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "Oren",
        body: "שרות יעיל, מקצועי, אמין עם יכולת יצירת קשר ומענה מהיר ורציף. בהחלט מומלץ",
        date: "22 במאי 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/uLGgEMMBGoXhutZd9"
      },
      {
        name: "Revital N.",
        body: "מדהימים , שירותיים , מקצועיים , ממליצה מאודדדדד ! שירות ברמה אחרת , תודה לכם 🙏🏻❤️ …",
        date: "22 ביוני 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/6MoYDvNrTTsn7R5a9"
      },
      {
        name: "Rami Q.",
        body: "הצוות של ויזהנט היה מקצועי, מהיר, זמין תמיד, נותן מענה לכל שאלה והויזה הגיעה תוך יום. ממליץ בחום!",
        date: "2 בפברואר 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/Z25ogVAN7Tpp6aVTA"
      },
      {
        name: "דורון ק.",
        body: "ויזה.נט שרות מעולה ומהיר <br/>שווה כל שקל חוסך הרבה כאב ראש",
        date: "17 באפריל 2023",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "יפה ס.",
        body: "שרות מושלם הכל נעשה תוך דקות בלי התברברות ובירוקרטיה מול הרשויות, העמלה שהם לוקחים סבירה ביותר וחסכה לי זמן ועצבים! ממליצה מאוד!",
        date: "17 במאי 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/jFjYSoptsvqDkZqj9"
      },
      {
        name: "Yuval S.",
        body: "שירות מדהים! מקצועיים יעילים וזריזים! ממליצה מאוד",
        date: "13 בספטמבר 2023",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "עדי ס.",
        body: "שירות לקוחות מדהים!!! מישהי הייתה איתי יחד בוואטסאפ לכל אורך תהליך מילוי הויזה. הויזה הגיעה מהר. ממליצה בחום!",
        date: "19 במרץ 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/4vb6JiK4RuBXpRix8"
      }
    ],
    vietnam: [
      {
        name: "לימור מ.",
        body: "היינו צריכים ויזה דחופה תוך יומיים לויאטנם ואורן היה מדהים, ליווה אותנו לאורך התהליך שווה כל שקל אז לכל הספונטנים שמחליטים מהיום למחר לנסוע ויזהנט זה המקום",
        date: "10 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/84KSwCfetkJKnQdWA"
      },
      {
        name: "Yehuda N.",
        body: "ברצוני להודות מכל הלב לאורן נציג השירות שטיפל בי במסירות ובאדיבות ....תוך מענה לכל השאלות ...וממש בפחות מ 24 שעות כבר קיבלתי את הויזה ...תוך כדי מתן הסברים וסיוע...לכן אני מבקש להודות על השירות וגם להמליץ עליו...תודה רבה",
        date: "9 באוקטובר 2024",
        img: "easy.png",
        url: "https://easy.co.il/page/10122959"
      },
      {
        name: "Zvi S.",
        body: "הזמנתי ויזה לויטנאם תוך כמה ימים קיבלתי את הויזה למייל. ממליץ להזמין מהם.",
        date: "19 ביולי 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/Wg3wAYTU4CkhRkx96"
      },
      {
        name: "Nira S.",
        body: "יחס אישי מהיר ונוח ממש קל ופשוט ממליצה מאוד",
        date: "28 באפריל 2025",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "Sabrin N.",
        body: "מושלםםםם , מעל ומעבר , סבלנות ואדיבות שאין דברים כאלה, מקצועיות ברמה הכי גבוהה שיש, שירות סוף הדרך! ממליצה בחום! ותודה מכל הלב🩵 …",
        date: "18 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/m1F42Z4iBQSLNYJC8"
      },
      {
        name: "Revital N.",
        body: "מדהימים , שירותיים , מקצועיים , ממליצה מאודדדדד ! שירות ברמה אחרת , תודה לכם 🙏🏻❤️ …",
        date: "22 ביוני 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/6MoYDvNrTTsn7R5a9"
      }
    ],
    india: [
      {
        name: "Omer L.",
        body: "הזמנתי טיסה להודו ליום למחרת בלילה ולויזה לוקח בדר״כ יומיים שלושה להגיע. הם יצרו איתי קשר ומיוזמתם העבירו אותי למסלול דחוף וביום למחרת ב10 בבוקר כבר הייתה לי ויזה. השירות היה אדיב ונעים והרגשתי שהם באמת דואגים לי ועושים כל שביכולתם כדי שאקבל את הויזה בזמן. ממליץ בחום!",
        date: "17 באפריל 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/kpshQ1fq9MxWoQfz9"
      },
      {
        name: "Yehuda N.",
        body: "ברצוני להודות מכל הלב לאורן נציג השירות שטיפל בי במסירות ובאדיבות ....תוך מענה לכל השאלות ...וממש בפחות מ 24 שעות כבר קיבלתי את הויזה ...תוך כדי מתן הסברים וסיוע...לכן אני מבקש להודות על השירות וגם להמליץ עליו...תודה רבה",
        date: "9 באוקטובר 2024",
        img: "easy.png",
        url: "https://easy.co.il/page/10122959"
      },
      {
        name: "Nimrod B.",
        body: "I requested an urgent visa to India and received it in under 24 hours. Professional and quick service. Thank you!",
        date: "26 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/XbqwPqsYj3dnYaGZ6"
      },
      {
        name: "Nira S.",
        body: "יחס אישי מהיר ונוח ממש קל ופשוט ממליצה מאוד",
        date: "28 באפריל 2025",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "Oren",
        body: "שרות יעיל, מקצועי, אמין עם יכולת יצירת קשר ומענה מהיר ורציף. בהחלט מומלץ",
        date: "22 במאי 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/uLGgEMMBGoXhutZd9"
      },
      {
        name: "Sabrin N.",
        body: "מושלםםםם , מעל ומעבר , סבלנות ואדיבות שאין דברים כאלה, מקצועיות ברמה הכי גבוהה שיש, שירות סוף הדרך! ממליצה בחום! ותודה מכל הלב🩵 …",
        date: "18 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/m1F42Z4iBQSLNYJC8"
      },
      {
        name: "מני מ.",
        body: "כל כך קל ופשוט..מילאתי פרטים,שילמתי וקיבלתי תוך יומיים..בלי כאבי ראש טבלי בלבולי מוח..פשוט שירות מושלם! ממליץ מאוד מאוד!!",
        date: "11 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/XgZ6U4WiDdg37HB59"
      },
      {
        name: "דורון ק.",
        body: "ויזה.נט שרות מעולה ומהיר <br/>שווה כל שקל חוסך הרבה כאב ראש",
        date: "17 באפריל 2023",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      }
    ],
    usa: [
      {
        name: "Evgeny F.",
        body: "פחות מ-48 שעות לפני הטיסה גיליתי שהויזה שלי לא בתוקף. תוך 17 שעות קיבלתי ויזה ESTA . אלופים!",
        date: "9 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/2QyvwMjeQekCPkuk9"
      },
      {
        name: "Sabrin N.",
        body: "מושלםםםם , מעל ומעבר , סבלנות ואדיבות שאין דברים כאלה, מקצועיות ברמה הכי גבוהה שיש, שירות סוף הדרך! ממליצה בחום! ותודה מכל הלב🩵 …",
        date: "18 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/m1F42Z4iBQSLNYJC8"
      },
      {
        name: "Meravi K.",
        body: "אתמול הגשתי והבוקר אושר לי🎊🎊🎊 תודה רבה רבה רבה לאורן היקר מ-ויזה נט ששיחק אותה עם שירות אדיב,ידע רב,ניסיון משמעותי,במענה טלפוני וכן בווצאפ,לא הרגשתי לבד ולא נשארתי עם סימני שאלה כלל!עם הקשבה ונכונות רבה מאד, והבוקר הפתיע אותי עם האישור🎉🎉🎉אורן אתה אלוף,אין עלייך!!!שירות מספר 1🏆🥇ממליצה בחום ובאהבה🌟❤️🌟",
        date: "2 בינואר 2024",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "עדי ס.",
        body: "שירות לקוחות מדהים!!! מישהי הייתה איתי יחד בוואטסאפ לכל אורך תהליך מילוי הויזה. הויזה הגיעה מהר. ממליצה בחום!",
        date: "19 במרץ 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/4vb6JiK4RuBXpRix8"
      },
      {
        name: "מני מ.",
        body: "כל כך קל ופשוט..מילאתי פרטים,שילמתי וקיבלתי תוך יומיים..בלי כאבי ראש טבלי בלבולי מוח..פשוט שירות מושלם! ממליץ מאוד מאוד!!",
        date: "11 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/XgZ6U4WiDdg37HB59"
      },
      {
        name: "Yehuda N.",
        body: "ברצוני להודות מכל הלב לאורן נציג השירות שטיפל בי במסירות ובאדיבות ....תוך מענה לכל השאלות ...וממש בפחות מ 24 שעות כבר קיבלתי את הויזה ...תוך כדי מתן הסברים וסיוע...לכן אני מבקש להודות על השירות וגם להמליץ עליו...תודה רבה",
        date: "9 באוקטובר 2024",
        img: "easy.png",
        url: "https://easy.co.il/page/10122959"
      },
      {
        name: "Nira S.",
        body: "יחס אישי מהיר ונוח ממש קל ופשוט ממליצה מאוד",
        date: "28 באפריל 2025",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "Rami Q.",
        body: "הצוות של ויזהנט היה מקצועי, מהיר, זמין תמיד, נותן מענה לכל שאלה והויזה הגיעה תוך יום. ממליץ בחום!",
        date: "2 בפברואר 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/Z25ogVAN7Tpp6aVTA"
      },
      {
        name: "יפה ס.",
        body: "שרות מושלם הכל נעשה תוך דקות בלי התברברות ובירוקרטיה מול הרשויות, העמלה שהם לוקחים סבירה ביותר וחסכה לי זמן ועצבים! ממליצה מאוד!",
        date: "17 במאי 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/jFjYSoptsvqDkZqj9"
      },
      {
        name: "דורון ק.",
        body: "ויזה.נט שרות מעולה ומהיר <br>שווה כל שקל חוסך הרבה כאב ראש",
        date: "17 באפריל 2023",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      }
    ],
    uk: [
      {
        name: "Sabrin N.",
        body: "מושלםםםם , מעל ומעבר , סבלנות ואדיבות שאין דברים כאלה, מקצועיות ברמה הכי גבוהה שיש, שירות סוף הדרך! ממליצה בחום! ותודה מכל הלב🩵 …",
        date: "18 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/m1F42Z4iBQSLNYJC8"
      },
      {
        name: "Oren",
        body: "שרות יעיל, מקצועי, אמין עם יכולת יצירת קשר ומענה מהיר ורציף. בהחלט מומלץ",
        date: "22 במאי 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/uLGgEMMBGoXhutZd9"
      },
      {
        name: "Nira S.",
        body: "יחס אישי מהיר ונוח ממש קל ופשוט ממליצה מאוד",
        date: "28 באפריל 2025",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "מני מ.",
        body: "כל כך קל ופשוט..מילאתי פרטים,שילמתי וקיבלתי תוך יומיים..בלי כאבי ראש טבלי בלבולי מוח..פשוט שירות מושלם! ממליץ מאוד מאוד!!",
        date: "11 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/XgZ6U4WiDdg37HB59"
      },
      {
        name: "Revital N.",
        body: "מדהימים , שירותיים , מקצועיים , ממליצה מאודדדדד ! שירות ברמה אחרת , תודה לכם 🙏🏻❤️ …",
        date: "22 ביוני 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/6MoYDvNrTTsn7R5a9"
      },
      {
        name: "Yehuda N.",
        body: "ברצוני להודות מכל הלב לאורן נציג השירות שטיפל בי במסירות ובאדיבות ....תוך מענה לכל השאלות ...וממש בפחות מ 24 שעות כבר קיבלתי את הויזה ...תוך כדי מתן הסברים וסיוע...לכן אני מבקש להודות על השירות וגם להמליץ עליו...תודה רבה",
        date: "9 באוקטובר 2024",
        img: "easy.png",
        url: "https://easy.co.il/page/10122959"
      },
      {
        name: "דורון ק.",
        body: "ויזה.נט שרות מעולה ומהיר <br/>שווה כל שקל חוסך הרבה כאב ראש",
        date: "17 באפריל 2023",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "Rami Q.",
        body: "הצוות של ויזהנט היה מקצועי, מהיר, זמין תמיד, נותן מענה לכל שאלה והויזה הגיעה תוך יום. ממליץ בחום!",
        date: "2 בפברואר 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/Z25ogVAN7Tpp6aVTA"
      },
      {
        name: "יפה ס.",
        body: "שרות מושלם הכל נעשה תוך דקות בלי התברברות ובירוקרטיה מול הרשויות, העמלה שהם לוקחים סבירה ביותר וחסכה לי זמן ועצבים! ממליצה מאוד!",
        date: "17 במאי 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/jFjYSoptsvqDkZqj9"
      },
      {
        name: "עדי ס.",
        body: "שירות לקוחות מדהים!!! מישהי הייתה איתי יחד בוואטסאפ לכל אורך תהליך מילוי הויזה. הויזה הגיעה מהר. ממליצה בחום!",
        date: "19 במרץ 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/4vb6JiK4RuBXpRix8"
      }
    ],
    sri_lanka: [
      {
        name: "אילן מ.",
        body: "חברה רצינית להנפקת ויזות. אני אישית עשיתי ויזות לסרילנקה לכל המשפחה וקיבלתי תוך יומיים. מענה מהיר לכל בעיה וטיפול מסור. תודה רבה לכם ....תמשיכו כך.",
        date: "11 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/7bbYEzHAXLauFAM98"
      },
      {
        name: "Sabrin N.",
        body: "מושלםםםם , מעל ומעבר , סבלנות ואדיבות שאין דברים כאלה, מקצועיות ברמה הכי גבוהה שיש, שירות סוף הדרך! ממליצה בחום! ותודה מכל הלב🩵 …",
        date: "18 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/m1F42Z4iBQSLNYJC8"
      },
      {
        name: "Oren",
        body: "שרות יעיל, מקצועי, אמין עם יכולת יצירת קשר ומענה מהיר ורציף. בהחלט מומלץ",
        date: "22 במאי 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/uLGgEMMBGoXhutZd9"
      },
      {
        name: "Nira S.",
        body: "יחס אישי מהיר ונוח ממש קל ופשוט ממליצה מאוד",
        date: "28 באפריל 2025",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "מני מ.",
        body: "כל כך קל ופשוט..מילאתי פרטים,שילמתי וקיבלתי תוך יומיים..בלי כאבי ראש טבלי בלבולי מוח..פשוט שירות מושלם! ממליץ מאוד מאוד!!",
        date: "11 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/XgZ6U4WiDdg37HB59"
      },
      {
        name: "Revital N.",
        body: "מדהימים , שירותיים , מקצועיים , ממליצה מאודדדדד ! שירות ברמה אחרת , תודה לכם 🙏🏻❤️ …",
        date: "22 ביוני 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/6MoYDvNrTTsn7R5a9"
      },
      {
        name: "דורון ק.",
        body: "ויזה.נט שרות מעולה ומהיר <br/>שווה כל שקל חוסך הרבה כאב ראש",
        date: "17 באפריל 2023",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "Rami Q.",
        body: "הצוות של ויזהנט היה מקצועי, מהיר, זמין תמיד, נותן מענה לכל שאלה והויזה הגיעה תוך יום. ממליץ בחום!",
        date: "2 בפברואר 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/Z25ogVAN7Tpp6aVTA"
      }
    ],
    canada: [
      {
        name: "תמר פ.",
        body: "בבוקר הטיסה, 5 שעות לפני, גיליתי לדאבוני שלא עשיתי ויזה לקנדה. מיד הגשתי בקשה ודיברתי עם אורן מהחברה בטלפון. הוא היה מקסים! ישר נענה לעזרתי ותוך כשעתיים הכול היה מסודר. אין מילים להודות לכם, בזכותכם אני טסה היום!!!",
        date: "6 ביוני 2023",
        img: "google.png",
        url: "https://maps.app.goo.gl/WGmWTWgXYrUhHPSE7"
      },
      {
        name: "Sabrin N.",
        body: "מושלםםםם , מעל ומעבר , סבלנות ואדיבות שאין דברים כאלה, מקצועיות ברמה הכי גבוהה שיש, שירות סוף הדרך! ממליצה בחום! ותודה מכל הלב🩵 …",
        date: "18 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/m1F42Z4iBQSLNYJC8"
      },
      {
        name: "Oren",
        body: "שרות יעיל, מקצועי, אמין עם יכולת יצירת קשר ומענה מהיר ורציף. בהחלט מומלץ",
        date: "22 במאי 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/uLGgEMMBGoXhutZd9"
      },
      {
        name: "Nira S.",
        body: "יחס אישי מהיר ונוח ממש קל ופשוט ממליצה מאוד",
        date: "28 באפריל 2025",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "מני מ.",
        body: "כל כך קל ופשוט..מילאתי פרטים,שילמתי וקיבלתי תוך יומיים..בלי כאבי ראש טבלי בלבולי מוח..פשוט שירות מושלם! ממליץ מאוד מאוד!!",
        date: "11 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/XgZ6U4WiDdg37HB59"
      },
      {
        name: "Revital N.",
        body: "מדהימים , שירותיים , מקצועיים , ממליצה מאודדדדד ! שירות ברמה אחרת , תודה לכם 🙏🏻❤️ …",
        date: "22 ביוני 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/6MoYDvNrTTsn7R5a9"
      },
      {
        name: "דורון ק.",
        body: "ויזה.נט שרות מעולה ומהיר <br/>שווה כל שקל חוסך הרבה כאב ראש",
        date: "17 באפריל 2023",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "Rami Q.",
        body: "הצוות של ויזהנט היה מקצועי, מהיר, זמין תמיד, נותן מענה לכל שאלה והויזה הגיעה תוך יום. ממליץ בחום!",
        date: "2 בפברואר 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/Z25ogVAN7Tpp6aVTA"
      }
    ],
    morocco: [
      {
        name: "Moti B.",
        body: "הוצאנו ויזות למרוקו. קיבלנו שירות מקצועי, אמין, ידידותי , טיפול מהיר ומיידי בכל בקשה שאלה ובעיה שצצה במהלך הוצאת הויזה. מומלץ ביותר 💐✌",
        date: "3 באוגוסט 2025",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "Sabrin N.",
        body: "מושלםםםם , מעל ומעבר , סבלנות ואדיבות שאין דברים כאלה, מקצועיות ברמה הכי גבוהה שיש, שירות סוף הדרך! ממליצה בחום! ותודה מכל הלב🩵 …",
        date: "18 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/m1F42Z4iBQSLNYJC8"
      },
      {
        name: "Nira S.",
        body: "יחס אישי מהיר ונוח ממש קל ופשוט ממליצה מאוד",
        date: "28 באפריל 2025",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "מני מ.",
        body: "כל כך קל ופשוט..מילאתי פרטים,שילמתי וקיבלתי תוך יומיים..בלי כאבי ראש טבלי בלבולי מוח..פשוט שירות מושלם! ממליץ מאוד מאוד!!",
        date: "11 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/XgZ6U4WiDdg37HB59"
      },
      {
        name: "Revital N.",
        body: "מדהימים , שירותיים , מקצועיים , ממליצה מאודדדדד ! שירות ברמה אחרת , תודה לכם 🙏🏻❤️ …",
        date: "22 ביוני 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/6MoYDvNrTTsn7R5a9"
      },
      {
        name: "דורון ק.",
        body: "ויזה.נט שרות מעולה ומהיר <br/>שווה כל שקל חוסך הרבה כאב ראש",
        date: "17 באפריל 2023",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "Rami Q.",
        body: "הצוות של ויזהנט היה מקצועי, מהיר, זמין תמיד, נותן מענה לכל שאלה והויזה הגיעה תוך יום. ממליץ בחום!",
        date: "2 בפברואר 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/Z25ogVAN7Tpp6aVTA"
      },
      {
        name: "יפה ס.",
        body: "שרות מושלם הכל נעשה תוך דקות בלי התברברות ובירוקרטיה מול הרשויות, העמלה שהם לוקחים סבירה ביותר וחסכה לי זמן ועצבים! ממליצה מאוד!",
        date: "17 במאי 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/jFjYSoptsvqDkZqj9"
      },
      {
        name: "Yuval S.",
        body: "שירות מדהים! מקצועיים יעילים וזריזים! ממליצה מאוד",
        date: "13 בספטמבר 2023",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "עדי ס.",
        body: "שירות לקוחות מדהים!!! מישהי הייתה איתי יחד בוואטסאפ לכל אורך תהליך מילוי הויזה. הויזה הגיעה מהר. ממליצה בחום!",
        date: "19 במרץ 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/4vb6JiK4RuBXpRix8"
      }
    ],
    israel: [
      {
        name: "Sabrin N.",
        body: "מושלםםםם , מעל ומעבר , סבלנות ואדיבות שאין דברים כאלה, מקצועיות ברמה הכי גבוהה שיש, שירות סוף הדרך! ממליצה בחום! ותודה מכל הלב🩵 …",
        date: "18 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/m1F42Z4iBQSLNYJC8"
      },
      {
        name: "Oren",
        body: "שרות יעיל, מקצועי, אמין עם יכולת יצירת קשר ומענה מהיר ורציף. בהחלט מומלץ",
        date: "22 במאי 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/uLGgEMMBGoXhutZd9"
      },
      {
        name: "Nira S.",
        body: "יחס אישי מהיר ונוח ממש קל ופשוט ממליצה מאוד",
        date: "28 באפריל 2025",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "מני מ.",
        body: "כל כך קל ופשוט..מילאתי פרטים,שילמתי וקיבלתי תוך יומיים..בלי כאבי ראש טבלי בלבולי מוח..פשוט שירות מושלם! ממליץ מאוד מאוד!!",
        date: "11 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/XgZ6U4WiDdg37HB59"
      },
      {
        name: "Revital N.",
        body: "מדהימים , שירותיים , מקצועיים , ממליצה מאודדדדד ! שירות ברמה אחרת , תודה לכם 🙏🏻❤️ …",
        date: "22 ביוני 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/6MoYDvNrTTsn7R5a9"
      },
      {
        name: "דורון ק.",
        body: "ויזה.נט שרות מעולה ומהיר <br/>שווה כל שקל חוסך הרבה כאב ראש",
        date: "17 באפריל 2023",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "Yuval S.",
        body: "שירות מדהים! מקצועיים יעילים וזריזים! ממליצה מאוד",
        date: "13 בספטמבר 2023",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "עדי ס.",
        body: "שירות לקוחות מדהים!!! מישהי הייתה איתי יחד בוואטסאפ לכל אורך תהליך מילוי הויזה. הויזה הגיעה מהר. ממליצה בחום!",
        date: "19 במרץ 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/4vb6JiK4RuBXpRix8"
      }
    ],
    korea: [
      {
        name: "Sabrin N.",
        body: "מושלםםםם , מעל ומעבר , סבלנות ואדיבות שאין דברים כאלה, מקצועיות ברמה הכי גבוהה שיש, שירות סוף הדרך! ממליצה בחום! ותודה מכל הלב🩵 …",
        date: "18 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/m1F42Z4iBQSLNYJC8"
      },
      {
        name: "Oren",
        body: "שרות יעיל, מקצועי, אמין עם יכולת יצירת קשר ומענה מהיר ורציף. בהחלט מומלץ",
        date: "22 במאי 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/uLGgEMMBGoXhutZd9"
      },
      {
        name: "Nira S.",
        body: "יחס אישי מהיר ונוח ממש קל ופשוט ממליצה מאוד",
        date: "28 באפריל 2025",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "מני מ.",
        body: "כל כך קל ופשוט..מילאתי פרטים,שילמתי וקיבלתי תוך יומיים..בלי כאבי ראש טבלי בלבולי מוח..פשוט שירות מושלם! ממליץ מאוד מאוד!!",
        date: "11 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/XgZ6U4WiDdg37HB59"
      },
      {
        name: "Revital N.",
        body: "מדהימים , שירותיים , מקצועיים , ממליצה מאודדדדד ! שירות ברמה אחרת , תודה לכם 🙏🏻❤️ …",
        date: "22 ביוני 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/6MoYDvNrTTsn7R5a9"
      },
      {
        name: "דורון ק.",
        body: "ויזה.נט שרות מעולה ומהיר <br/>שווה כל שקל חוסך הרבה כאב ראש",
        date: "17 באפריל 2023",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "Rami Q.",
        body: "הצוות של ויזהנט היה מקצועי, מהיר, זמין תמיד, נותן מענה לכל שאלה והויזה הגיעה תוך יום. ממליץ בחום!",
        date: "2 בפברואר 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/Z25ogVAN7Tpp6aVTA"
      },
      {
        name: "יפה ס.",
        body: "שרות מושלם הכל נעשה תוך דקות בלי התברברות ובירוקרטיה מול הרשויות, העמלה שהם לוקחים סבירה ביותר וחסכה לי זמן ועצבים! ממליצה מאוד!",
        date: "17 במאי 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/jFjYSoptsvqDkZqj9"
      }
    ],
    thailand: [
      {
        name: "Sabrin N.",
        body: "מושלםםםם , מעל ומעבר , סבלנות ואדיבות שאין דברים כאלה, מקצועיות ברמה הכי גבוהה שיש, שירות סוף הדרך! ממליצה בחום! ותודה מכל הלב🩵 …",
        date: "18 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/m1F42Z4iBQSLNYJC8"
      },
      {
        name: "Oren",
        body: "שרות יעיל, מקצועי, אמין עם יכולת יצירת קשר ומענה מהיר ורציף. בהחלט מומלץ",
        date: "22 במאי 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/uLGgEMMBGoXhutZd9"
      },
      {
        name: "Nira S.",
        body: "יחס אישי מהיר ונוח ממש קל ופשוט ממליצה מאוד",
        date: "28 באפריל 2025",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "מני מ.",
        body: "כל כך קל ופשוט..מילאתי פרטים,שילמתי וקיבלתי תוך יומיים..בלי כאבי ראש טבלי בלבולי מוח..פשוט שירות מושלם! ממליץ מאוד מאוד!!",
        date: "11 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/XgZ6U4WiDdg37HB59"
      },
      {
        name: "Revital N.",
        body: "מדהימים , שירותיים , מקצועיים , ממליצה מאודדדדד ! שירות ברמה אחרת , תודה לכם 🙏🏻❤️ …",
        date: "22 ביוני 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/6MoYDvNrTTsn7R5a9"
      },
      {
        name: "דורון ק.",
        body: "ויזה.נט שרות מעולה ומהיר <br/>שווה כל שקל חוסך הרבה כאב ראש",
        date: "17 באפריל 2023",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "Rami Q.",
        body: "הצוות של ויזהנט היה מקצועי, מהיר, זמין תמיד, נותן מענה לכל שאלה והויזה הגיעה תוך יום. ממליץ בחום!",
        date: "2 בפברואר 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/Z25ogVAN7Tpp6aVTA"
      },
      {
        name: "יפה ס.",
        body: "שרות מושלם הכל נעשה תוך דקות בלי התברברות ובירוקרטיה מול הרשויות, העמלה שהם לוקחים סבירה ביותר וחסכה לי זמן ועצבים! ממליצה מאוד!",
        date: "17 במאי 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/jFjYSoptsvqDkZqj9"
      }
    ],
    cambodia: [
      {
        name: "Sabrin N.",
        body: "מושלםםםם , מעל ומעבר , סבלנות ואדיבות שאין דברים כאלה, מקצועיות ברמה הכי גבוהה שיש, שירות סוף הדרך! ממליצה בחום! ותודה מכל הלב🩵 …",
        date: "18 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/m1F42Z4iBQSLNYJC8"
      },
      {
        name: "Oren",
        body: "שרות יעיל, מקצועי, אמין עם יכולת יצירת קשר ומענה מהיר ורציף. בהחלט מומלץ",
        date: "22 במאי 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/uLGgEMMBGoXhutZd9"
      },
      {
        name: "Nira S.",
        body: "יחס אישי מהיר ונוח ממש קל ופשוט ממליצה מאוד",
        date: "28 באפריל 2025",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "מני מ.",
        body: "כל כך קל ופשוט..מילאתי פרטים,שילמתי וקיבלתי תוך יומיים..בלי כאבי ראש טבלי בלבולי מוח..פשוט שירות מושלם! ממליץ מאוד מאוד!!",
        date: "11 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/XgZ6U4WiDdg37HB59"
      },
      {
        name: "Revital N.",
        body: "מדהימים , שירותיים , מקצועיים , ממליצה מאודדדדד ! שירות ברמה אחרת , תודה לכם 🙏🏻❤️ …",
        date: "22 ביוני 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/6MoYDvNrTTsn7R5a9"
      },
      {
        name: "דורון ק.",
        body: "ויזה.נט שרות מעולה ומהיר <br/>שווה כל שקל חוסך הרבה כאב ראש",
        date: "17 באפריל 2023",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "Rami Q.",
        body: "הצוות של ויזהנט היה מקצועי, מהיר, זמין תמיד, נותן מענה לכל שאלה והויזה הגיעה תוך יום. ממליץ בחום!",
        date: "2 בפברואר 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/Z25ogVAN7Tpp6aVTA"
      },
      {
        name: "יפה ס.",
        body: "שרות מושלם הכל נעשה תוך דקות בלי התברברות ובירוקרטיה מול הרשויות, העמלה שהם לוקחים סבירה ביותר וחסכה לי זמן ועצבים! ממליצה מאוד!",
        date: "17 במאי 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/jFjYSoptsvqDkZqj9"
      }
    ],
    new_zealand: [
      {
        name: "Sabrin N.",
        body: "מושלםםםם , מעל ומעבר , סבלנות ואדיבות שאין דברים כאלה, מקצועיות ברמה הכי גבוהה שיש, שירות סוף הדרך! ממליצה בחום! ותודה מכל הלב🩵 …",
        date: "18 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/m1F42Z4iBQSLNYJC8"
      },
      {
        name: "Oren",
        body: "שרות יעיל, מקצועי, אמין עם יכולת יצירת קשר ומענה מהיר ורציף. בהחלט מומלץ",
        date: "22 במאי 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/uLGgEMMBGoXhutZd9"
      },
      {
        name: "Nira S.",
        body: "יחס אישי מהיר ונוח ממש קל ופשוט ממליצה מאוד",
        date: "28 באפריל 2025",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "מני מ.",
        body: "כל כך קל ופשוט..מילאתי פרטים,שילמתי וקיבלתי תוך יומיים..בלי כאבי ראש טבלי בלבולי מוח..פשוט שירות מושלם! ממליץ מאוד מאוד!!",
        date: "11 באפריל 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/XgZ6U4WiDdg37HB59"
      },
      {
        name: "Revital N.",
        body: "מדהימים , שירותיים , מקצועיים , ממליצה מאודדדדד ! שירות ברמה אחרת , תודה לכם 🙏🏻❤️ …",
        date: "22 ביוני 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/6MoYDvNrTTsn7R5a9"
      },
      {
        name: "דורון ק.",
        body: "ויזה.נט שרות מעולה ומהיר <br/>שווה כל שקל חוסך הרבה כאב ראש",
        date: "17 באפריל 2023",
        img: "facebook.png",
        url: "https://he-il.facebook.com/visanet.co.il"
      },
      {
        name: "Rami Q.",
        body: "הצוות של ויזהנט היה מקצועי, מהיר, זמין תמיד, נותן מענה לכל שאלה והויזה הגיעה תוך יום. ממליץ בחום!",
        date: "2 בפברואר 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/Z25ogVAN7Tpp6aVTA"
      },
      {
        name: "יפה ס.",
        body: "שרות מושלם הכל נעשה תוך דקות בלי התברברות ובירוקרטיה מול הרשויות, העמלה שהם לוקחים סבירה ביותר וחסכה לי זמן ועצבים! ממליצה מאוד!",
        date: "17 במאי 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/jFjYSoptsvqDkZqj9"
      }
    ]
  },
  ru: {
    home: [
      {
        name: "Nadezhda A.",
        body: "Отличная фирма, вежливо, четко, быстро! Всем рекомендую!",
        date: "14 января 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/1fohsBpUoB8FugX7A"
      },
      {
        name: "Гульнара З.",
        body: "Понравился визовый центр тем, что никуда ездить не нужно, быстрое оформление, всё чётко профессионально.",
        date: "4 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/ZDaNuFEESu1tppPE9"
      },
      {
        name: "Vitaliy B.",
        body: "Очень удобный и понятный сервис. Обратился в визанет после неудачного обращения в другую службу. Положительный контраст: заказ визы сопровождается констатацией промежуточных этапов, что важно для понимания процесса заказа. Виза оформлена очень быстро",
        date: "29 сентября 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Anton S.",
        body: "Прекрасный сервис где все можно сделать дистанционно! Вежливые менеджеры отзывчивы и нацелены на результат, проявляют заинтересованность.",
        date: "29 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/HKbV2MxPrAQ8znNf9"
      },
      {
        name: "Мария О.",
        body: "Сопровождали меня на каждом этапе, очень понравилось отношение.",
        date: "28 мая 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864"
      },
      {
        name: "Соня Б.",
        body: "Отвечали на мои вопросы даже в выходной день) Ответственно подходят к делу",
        date: "5 мая 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/4XqEyMB4uvmZ2iw79"
      }
    ],
    india: [
      {
        name: "Виктор Б.",
        body: "Огромная благодарность компании за помощь в оформлении срочной визы в Индию. Купили билеты и за сутки поняли, что у нас нет визы))) обратились в Визанет в 16 часов в пятницу, а вылет в субботу вечером , на следующей день в 17 часов нам прислали визы!! Ещё раз большое спасибо! Удобный сайт, экспертное общение и качественное оказание услуги!",
        date: "18 января 2025",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Юлия",
        body: "Визу в Индию получила буквально за несколько дней, цена оправдана",
        date: "23 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/MP6kB6DfodkXQ5Ys9"
      },
      {
        name: "Михаил С.",
        body: "Спасибо за помощь с визой в Индию. Очень оперативно и профессионально все оформили.",
        date: "11 февраля 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864"
      },
      {
        name: "Ольга Р.",
        body: "Добрый вечер! Отличное и качественное обслуживание, а главное- цены приемлемые. 5 летнюю визу в Индию оформили без проблем. Ранее я сама оформляла визу, но сейчас проблемы с оплатой. На сервисе все сделали быстро и качественно. Спасибо.",
        date: "18 октября 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Юлия А.",
        body: "Получали тут визы в Индию. Все анкеты заполняли на сайте без посещения офиса. Визы получили даже без бронирования отеля.",
        date: "3 февраля 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/aKeuZpJ2cPY2eXpR7"
      },
      {
        name: "Роман Г.",
        body: "Заказывал тут визу в Индию. Сделали всё чётко и быстро за несколько дней. Сервис рекомендую!",
        date: "11 января 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/o7eKcT52j2jQkQMR6"
      },
      {
        name: "Дарья З.",
        body: "Индия наконец-то открылась после длительного перерыва. Сделала тут туристическую онлайн визу. Выдали за два дня. Рекомендую!",
        date: "19 октября 2021",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      }
    ],
    indonesia: [
      {
        name: "Sam P.",
        body: "В Индонезию визу сделали за 3 дня, быстро оформляют и отвечают на все вопросы 24/7. Доволен.",
        date: "6 октября 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/cTAXwbWewE7ojtq4A"
      },
      {
        name: "Гульнара З.",
        body: "Понравился визовый центр тем, что никуда ездить не нужно, быстрое оформление, всё чётко профессионально.",
        date: "4 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/ZDaNuFEESu1tppPE9"
      },
      {
        name: "Vitaliy B.",
        body: "Очень удобный и понятный сервис. Обратился в визанет после неудачного обращения в другую службу. Положительный контраст: заказ визы сопровождается констатацией промежуточных этапов, что важно для понимания процесса заказа. Виза оформлена очень быстро",
        date: "29 сентября 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Anton S.",
        body: "Прекрасный сервис где все можно сделать дистанционно! Вежливые менеджеры отзывчивы и нацелены на результат, проявляют заинтересованность.",
        date: "29 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/HKbV2MxPrAQ8znNf9"
      },
      {
        name: "Мария О.",
        body: "Сопровождали меня на каждом этапе, очень понравилось отношение.",
        date: "28 мая 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864"
      },
      {
        name: "Соня Б.",
        body: "Отвечали на мои вопросы даже в выходной день) Ответственно подходят к делу",
        date: "5 мая 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/4XqEyMB4uvmZ2iw79"
      }
    ],
    israel: [
      {
        name: "Дмитрий Х.",
        body: "Отличный и быстрый сервис. Поддержка работает хорошо, отвечали быстро и сделали разрешение в Израиль за три дня.",
        date: "07 февраля 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/MmuUu27TqxZqArf48"
      },
      {
        name: "Варвара Б.",
        body: "Обращалась сюда за ЕТА в Израиль т.к с января это стало обязательно, сделали за один день",
        date: "25 декабря 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864"
      },
      {
        name: "Борис С.",
        body: "Самые лучшие впечатления. Впервые воспользовался услугами компании, надо было оформить ETA-IL для поездки в Израиль. Оформили в течение нескольких часов. Огромное спасибо! Всем рекомендую.",
        date: "9 января 2025",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Людмила",
        body: "Супер быстрое оформление, ЕТА в Израиль за один выходной день! Огромное спасибо!",
        date: "05 февраля 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/SfwSGv9iwH4KsLJa8"
      },
      {
        name: "Nadezhda A.",
        body: "Отличная фирма, вежливо, четко, быстро! Всем рекомендую!",
        date: "14 января 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/1fohsBpUoB8FugX7A"
      },
      {
        name: "Эльмира",
        body: "Оформляла визу в Израиль через компанию «Визанет.ру». Прошло все максимально легко и быстро за очень адекватные деньги. На всех этапах оформления на связи менеджер, который отвечает на все вопросы. Очень хороший сервис. Мне все понравилось.",
        date: "18 июня 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Гульнара З.",
        body: "Понравился визовый центр тем, что никуда ездить не нужно, быстрое оформление, всё чётко профессионально.",
        date: "4 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/ZDaNuFEESu1tppPE9"
      },
      {
        name: "Anton S.",
        body: "Прекрасный сервис где все можно сделать дистанционно! Вежливые менеджеры отзывчивы и нацелены на результат, проявляют заинтересованность.",
        date: "29 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/HKbV2MxPrAQ8znNf9"
      }
    ],
    korea: [
      {
        name: "Лоськова Т.",
        body: "Огромное спасибо компании за оформление K-ETA. Всё быстро, чётко, понятно, профессионально. Все документы заполняла на сайте. В чате оперативно отвечали на вопросы даже в выходные. Спасибо! Буду рекомендовать друзьям.",
        date: "12 февраля 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/hRJax3fyLhUdDDRP7"
      },
      {
        name: "Nadezhda A.",
        body: "Отличная фирма, вежливо, четко, быстро! Всем рекомендую!",
        date: "14 января 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/1fohsBpUoB8FugX7A"
      },
      {
        name: "Михаил А.",
        body: "Очень выручили меня со срочной визой в Корею. Спасибо!",
        date: "27 декабря 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864"
      },
      {
        name: "Людмила Ш.",
        body: "Оформляла визу в Южную Корею в этом сервисе. Виза электронная, оформляется онлайн просто и быстро и без посещения офиса и консульства. Также понравилась круглосуточная поддержка менеджеров. Рекомендую",
        date: "18 июня 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Татьяна Г.",
        body: "Максимально простая анкета, справилась быстро. Визу в Корею сделали за 2 дня 👍🏼",
        date: "8 декабря 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Лариса Л.",
        body: "Отличный сервис. Сделали срочно визу в Корею за один день!",
        date: "26 февраля 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/Y2TyNuT78BWJZS9c6"
      },
      {
        name: "Валентина Т.",
        body: "Оперативно сделали визу В Корею",
        date: "23 января 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864"
      },
      {
        name: "Юлия П.",
        body: "Через официальный сайт не получилось оформить визу в Южную Корею. Заказала тут, платила рос картой. Всё норм",
        date: "11 февраля 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      }
    ],
    saudi_arabia: [
      {
        name: "Nadezhda A.",
        body: "Отличная фирма, вежливо, четко, быстро! Всем рекомендую!",
        date: "14 января 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/1fohsBpUoB8FugX7A"
      },
      {
        name: "Ермак К.",
        body: "Заказывал в Саудовскую Аравию, сначала боялся что дешево, но в итоге дали без проблем",
        date: "31 декабря 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864"
      },
      {
        name: "Vitaliy B.",
        body: "Очень удобный и понятный сервис. Обратился в визанет после неудачного обращения в другую службу. Положительный контраст: заказ визы сопровождается констатацией промежуточных этапов, что важно для понимания процесса заказа. Виза оформлена очень быстро",
        date: "29 сентября 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Anton S.",
        body: "Прекрасный сервис где все можно сделать дистанционно! Вежливые менеджеры отзывчивы и нацелены на результат, проявляют заинтересованность.",
        date: "29 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/HKbV2MxPrAQ8znNf9"
      },
      {
        name: "Гульнара З.",
        body: "Понравился визовый центр тем, что никуда ездить не нужно, быстрое оформление, всё чётко профессионально.",
        date: "4 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/ZDaNuFEESu1tppPE9"
      },
      {
        name: "Мария О.",
        body: "Сопровождали меня на каждом этапе, очень понравилось отношение.",
        date: "28 мая 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864"
      },
      {
        name: "Соня Б.",
        body: "Отвечали на мои вопросы даже в выходной день) Ответственно подходят к делу",
        date: "5 мая 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/4XqEyMB4uvmZ2iw79"
      }
    ],
    vietnam: [
      {
        name: "Вик",
        body: "Делали евизу 90 дней Вьетнам. Во первых наши карты Рф не принимают. А у посредников нет гарантии оплаты. Сервис виза нет не только оплатит но и заполнит и подаст за вас все документы. Всем советую. Переплата 2000 р экономит нервы и время на перевод документов. СПАСИБО.",
        date: "14 февраля 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/P1W9kPy4LLcU1zxP8"
      },
      {
        name: "Демид Ш.",
        body: "Получил тут e-visa во Вьетнам все было быстро и понятно. Большое спасибо.",
        date: "13 февраля 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864"
      },
      {
        name: "Nadezhda A.",
        body: "Отличная фирма, вежливо, четко, быстро! Всем рекомендую!",
        date: "14 января 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/1fohsBpUoB8FugX7A"
      },
      {
        name: "Виктория Д.",
        body: "Не первый раз использую услуги Визанет, в этот раз нужна была виза во Вьетнам. Как всегда быстро и без проблем. Оплата картой прошла без трудностей и через два дня виза уже была у меня. Теперь не терпится отправится в путешествие! Большое спасибо за отличный сервис!",
        date: "16 июня 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Гульнара З.",
        body: "Понравился визовый центр тем, что никуда ездить не нужно, быстрое оформление, всё чётко профессионально.",
        date: "4 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/ZDaNuFEESu1tppPE9"
      },
      {
        name: "Соня Б.",
        body: "Отвечали на мои вопросы даже в выходной день) Ответственно подходят к делу",
        date: "5 мая 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/4XqEyMB4uvmZ2iw79"
      }
    ],
    bahrain: [
      {
        name: "Nadezhda A.",
        body: "Отличная фирма, вежливо, четко, быстро! Всем рекомендую!",
        date: "14 января 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/1fohsBpUoB8FugX7A"
      },
      {
        name: "Гульнара З.",
        body: "Понравился визовый центр тем, что никуда ездить не нужно, быстрое оформление, всё чётко профессионально.",
        date: "4 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/ZDaNuFEESu1tppPE9"
      },
      {
        name: "Vitaliy B.",
        body: "Очень удобный и понятный сервис. Обратился в визанет после неудачного обращения в другую службу. Положительный контраст: заказ визы сопровождается констатацией промежуточных этапов, что важно для понимания процесса заказа. Виза оформлена очень быстро",
        date: "29 сентября 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Anton S.",
        body: "Прекрасный сервис где все можно сделать дистанционно! Вежливые менеджеры отзывчивы и нацелены на результат, проявляют заинтересованность.",
        date: "29 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/HKbV2MxPrAQ8znNf9"
      },
      {
        name: "Мария О.",
        body: "Сопровождали меня на каждом этапе, очень понравилось отношение.",
        date: "28 мая 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864"
      },
      {
        name: "Соня Б.",
        body: "Отвечали на мои вопросы даже в выходной день) Ответственно подходят к делу",
        date: "5 мая 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/4XqEyMB4uvmZ2iw79"
      }
    ],
    togo: [
      {
        name: "Nadezhda A.",
        body: "Отличная фирма, вежливо, четко, быстро! Всем рекомендую!",
        date: "14 января 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/1fohsBpUoB8FugX7A"
      },
      {
        name: "Гульнара З.",
        body: "Понравился визовый центр тем, что никуда ездить не нужно, быстрое оформление, всё чётко профессионально.",
        date: "4 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/ZDaNuFEESu1tppPE9"
      },
      {
        name: "Vitaliy B.",
        body: "Очень удобный и понятный сервис. Обратился в визанет после неудачного обращения в другую службу. Положительный контраст: заказ визы сопровождается констатацией промежуточных этапов, что важно для понимания процесса заказа. Виза оформлена очень быстро",
        date: "29 сентября 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Anton S.",
        body: "Прекрасный сервис где все можно сделать дистанционно! Вежливые менеджеры отзывчивы и нацелены на результат, проявляют заинтересованность.",
        date: "29 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/HKbV2MxPrAQ8znNf9"
      },
      {
        name: "Мария О.",
        body: "Сопровождали меня на каждом этапе, очень понравилось отношение.",
        date: "28 мая 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864"
      },
      {
        name: "Соня Б.",
        body: "Отвечали на мои вопросы даже в выходной день) Ответственно подходят к делу",
        date: "5 мая 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/4XqEyMB4uvmZ2iw79"
      }
    ],
    thailand: [
      {
        name: "Ева А.",
        body: "Оформила онлайн новую DTV визу в Тайланд на 5 лет, визанет помогли мне собрать недостающее документы и правильно сделать анкету, в общем всё под ключ. Огромная благодарность!",
        date: "17 мая 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/dGSkEyQ14REkKRGi9"
      },
      {
        name: "Nadezhda A.",
        body: "Отличная фирма, вежливо, четко, быстро! Всем рекомендую!",
        date: "14 января 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/1fohsBpUoB8FugX7A"
      },
      {
        name: "Vitaliy B.",
        body: "Очень удобный и понятный сервис. Обратился в визанет после неудачного обращения в другую службу. Положительный контраст: заказ визы сопровождается констатацией промежуточных этапов, что важно для понимания процесса заказа. Виза оформлена очень быстро",
        date: "29 сентября 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Мария О.",
        body: "Сопровождали меня на каждом этапе, очень понравилось отношение.",
        date: "28 мая 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864"
      },
      {
        name: "Гульнара З.",
        body: "Понравился визовый центр тем, что никуда ездить не нужно, быстрое оформление, всё чётко профессионально.",
        date: "4 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/ZDaNuFEESu1tppPE9"
      },
      {
        name: "Anton S.",
        body: "Прекрасный сервис где все можно сделать дистанционно! Вежливые менеджеры отзывчивы и нацелены на результат, проявляют заинтересованность.",
        date: "29 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/HKbV2MxPrAQ8znNf9"
      },
      {
        name: "Соня Б.",
        body: "Отвечали на мои вопросы даже в выходной день) Ответственно подходят к делу",
        date: "5 мая 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/4XqEyMB4uvmZ2iw79"
      }
    ],
    schengen: [
      {
        name: "Nadezhda A.",
        body: "Отличная фирма, вежливо, четко, быстро! Всем рекомендую!",
        date: "14 января 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/1fohsBpUoB8FugX7A"
      },
      {
        name: "Гульнара З.",
        body: "Понравился визовый центр тем, что никуда ездить не нужно, быстрое оформление, всё чётко профессионально.",
        date: "4 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/ZDaNuFEESu1tppPE9"
      },
      {
        name: "Vitaliy B.",
        body: "Очень удобный и понятный сервис. Обратился в визанет после неудачного обращения в другую службу. Положительный контраст: заказ визы сопровождается констатацией промежуточных этапов, что важно для понимания процесса заказа. Виза оформлена очень быстро",
        date: "29 сентября 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Anton S.",
        body: "Прекрасный сервис где все можно сделать дистанционно! Вежливые менеджеры отзывчивы и нацелены на результат, проявляют заинтересованность.",
        date: "29 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/HKbV2MxPrAQ8znNf9"
      },
      {
        name: "Мария О.",
        body: "Сопровождали меня на каждом этапе, очень понравилось отношение.",
        date: "28 мая 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864"
      },
      {
        name: "Соня Б.",
        body: "Отвечали на мои вопросы даже в выходной день) Ответственно подходят к делу",
        date: "5 мая 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/4XqEyMB4uvmZ2iw79"
      }
    ]
  },
  'ru-KZ': {}
} satisfies Record<LocaleCode, PageToTestimonials>;